var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wmsg",staticClass:"welcome-msg"},[_c('img',{staticClass:"hi",attrs:{"src":require("../image/icon-hi.png")}}),_c('div',{staticClass:"msg",domProps:{"innerHTML":_vm._s(_vm.current.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }